import { useQuery } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { Project } from '../types/project';
import type { Task } from '../types/task';
import customFetch from '../utils/fetch';
import { replaceGcsUrlWithSignedUrl } from '../utils/signed-url';
export const useGetTask = (taskId: number | undefined) => {
  const {
    data,
    isError,
    error,
    isLoading
  } = useQuery({
    queryKey: ['getTask', taskId],
    queryFn: async () => {
      const response = await customFetch(`${BASE_API_URL}/tasks/${taskId}`, {});
      const {
        task,
        error
      } = (await response.json() as {
        task: Task;
        error: string | undefined;
      });
      if (!response.ok) {
        throw new Error(error);
      }
      const projectResponse = await customFetch(`${BASE_API_URL}/projects/${task.projectId}`, {});
      const {
        project,
        error: projectError
      } = (await projectResponse.json() as {
        project: Project;
        error: string | undefined;
      });
      if (!projectResponse.ok) {
        throw new Error(projectError);
      }
      const taskWithSignedUrl = await replaceGcsUrlWithSignedUrl(task);
      return {
        task: taskWithSignedUrl,
        project
      };
    },
    enabled: Boolean(taskId),
    retry: false
  });
  return {
    isError,
    error,
    data,
    isLoading
  };
};